module.exports = __webpack_public_path__ + "static/img/banner-unvip.3e2df42.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/toefl/banner-unvip.png
// module id = DOD1
// module chunks = 96